module.exports = "/images/vendor/trumbowyg/dist/ui/icons.svg?5b01ba8be11eb713b41763472b62eefe";


//////////////////
// WEBPACK FOOTER
// ./node_modules/trumbowyg/dist/ui/icons.svg
// module id = +XyB
// module chunks = 0